module.exports = __webpack_public_path__ + "static/media/img30.7d1cfeef.jpg";